import React, { createContext, useContext, useState } from "react";

// Define the user context type
interface User {
  id: number;
  firstName: string;
  email: string;
  isadmin: boolean;
  
}

// Create the context with a default value
const UserContext = createContext<{
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}>({
  user: null,
  setUser: () => {},
});

// UserProvider component to provide the context
export const UserProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<User | null>(() => {
    // Retrieve user from localStorage if exists
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the UserContext
export const useUser = () => useContext(UserContext);
